import { Breadcrumbs as MantineBreadcrumbs } from "@mantine/core";
import { CSSProperties } from "react";
import { Link, useLocation } from "react-router-dom";

import { fontSizes } from "#app/theme/v1/fontSizes";
import { fontWeight } from "#app/theme/v1/fontWeights";
import { spacing } from "#app/theme/v1/spacing";
import { Icon } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";

import classes from "./Breadcrumbs.module.css";

type Props = {
  breadcrumbs: { label: string; href?: string }[];
};

export const Breadcrumbs = ({ breadcrumbs }: Props) => {
  const { pathname } = useLocation();

  return (
    <MantineBreadcrumbs separator={<Icon name="chevronRight" size={16} />}>
      {breadcrumbs.map((breadcrumb, index) => {
        const isFirst = index === 0;
        const isLast = index === breadcrumbs.length - 1;
        const isFirstAndLast = isFirst && isLast;

        return (
          <Group key={`${breadcrumb.label}-${index}`} style={{ gap: spacing.xs }}>
            <Link
              to={breadcrumb.href ?? "#"}
              className={classes.link}
              style={pathname === breadcrumb.href ? styles.currentPageLink : styles.link}
            >
              {breadcrumb.label}
            </Link>
            {isFirstAndLast && <Icon name="chevronRight" size={16} />}
          </Group>
        );
      })}
    </MantineBreadcrumbs>
  );
};
const styles: Record<string, CSSProperties> = {
  link: {
    fontSize: fontSizes.small,
    color: "black",
    textDecoration: "none",
  },
  currentPageLink: {
    fontSize: fontSizes.small,
    color: "black",
    textDecoration: "none",
    fontWeight: fontWeight.semiBold,
  },
};
